<template>
    <div
        class="target-savings padded-page"
        :class="{
            none: status === 'none',
            low: status === 'low',
        }"
        ref="screenWrapper"
    >
        <template v-if="status === 'high'">
            <div class="mb-5 text-white font-satoshi_r">
                <p class="text-lg">You saved a total of</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">
                    <CountUpNumber :endVal="reviewData?.total_savings ?? 0" currency="₦" />
                </p>
                <p>in 2025.</p>
            </div>
            <div class="grid gap-3 text-white font-satoshi_r">
                <p class="text-lg">
                    Sycamore paid you <span class="font-satoshi_b">{{ $format.renderCurrency(reviewData?.savings_returns) }}</span> in returns on your
                    savings
                </p>
                <p>
                    Your top savings category in 2025 was <span class="font-satoshi_b">{{ reviewData?.top_savings_category }}</span>
                </p>
            </div>
        </template>
        <template v-else-if="status === 'low'">
            <div class="mb-5 text-white font-satoshi_r">
                <p class="text-lg">You saved less than</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">
                    <CountUpNumber :endVal="reviewData?.total_savings ?? 0" currency="₦" />
                </p>
                <p>in total.</p>
            </div>
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p>
                    Small steps, big dreams! Keep saving <br />
                    consistently. Every bit brings you closer to your goals.
                </p>
            </div>
        </template>
        <template v-else>
            <div class="mb-5 text-white font-satoshi_r">
                <p class="text-lg mb-6">You’ve never created a savings plan 😔.</p>
                <p class="text-lg">Whatever your goals, we've got you covered. Start your savings journey today, earn up to</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">20% p.a.</p>
                <p>interest and crush your goals one plan at a time 💪🏽</p>
            </div>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        status() {
            if (this.reviewData?.total_savings <= 0) return "none";
            if (this.reviewData?.total_savings > 0 && this.reviewData?.total_savings < 50000) return "low";
            return "high";
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.target-savings {
    color: #1e4457;
    min-height: 100vh;

    background-color: #df3939;
    background-image: url("../../assets/images/year-in-review/target-savings.svg");
    background-size: auto 55%;
    background-repeat: no-repeat;
    background-position: bottom center;
}

.target-savings.low {
    background-image: url("../../assets/images/year-in-review/target-savings-low.svg");
}

.target-savings.none {
    background-image: url("../../assets/images/year-in-review/target-savings-none.svg");
}

@media (max-height: 750px) {
    .target-savings {
        background-size: auto 50%;
    }
}
</style>
